import styled, { keyframes } from 'styled-components';
import { shade } from 'polished';

export const Container = styled.div`
  /**Tem 100% da parte visível da tela que o usuário consegue ver */
  height: auto;
  /**Faz os items de dentro ficar todos um do lado do outro. */
  display: flex;
  /**Faz os items de dentro ter o mesmo tamanho, no caso, o tamanho de
    100vh */
  align-items: stretch;
  background-image: linear-gradient(#006000, #111111);
`;

const appearFromRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(70px);
  }
  to{
    opacity: 1;
    transform: translateX(0);
  }
`;

export const Content = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  max-width: auto;
  h1 {
    font-size: 25px;
    margin-bottom: 200px;
  }
`;

export const AnimationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  animation: ${appearFromRight} 1s;

  img {
    margin-top: 20px;
    margin-right: 30px;
    height: 120px;
  }

  form {
    margin: 30px 0;
    width: 340px;
    text-align: center;

    a {
      color: #f4ede8;
      display: block;
      margin-top: 14px;
      text-decoration: none;
      transition: color 0.2s;

      &:hover {
        color: ${shade(0.2, '#f4ede8')};
      }
    }
  }

  > a {
    color: #fff;
    display: block;
    text-decoration: none;
    transition: color 0.2s;
    margin-bottom: 20px;
    svg {
      margin-right: 16px;
    }

    &:hover {
      color: ${shade(0.2, '#fff')};
    }

    display: flex;
    align-items: center;
  }
  /**Ele estiliza apenas o 'a' que estar dentro do content. Assim, ele não
  sobrescreve nenhuma estilização de quaisquer outro 'a' que esteja em outro
  componente. */
`;

/** const centroLargura = keyframes`
  from {
    opacity: 0;
    width: 0px;
  }
  to{
    opacity: 1;
    transform: translateX(0);
    width: 300px;
  }
`; */

/** export const Background = styled.div`
  flex: 1;
  background: url(${signInBackGroundImg}) no-repeat center;
  background-size: cover;
`;
*/
